import type { MessageAttachment } from '../types';

// The server-owned attachment id only exists after the multipart request has
// been persisted. Keep a lightweight local copy on the optimistic user turn so
// the file chip does not disappear between Composer.clearFiles() and transcript
// hydration.
export const toOptimisticAttachments = (files: File[]): MessageAttachment[] =>
  files.map((file, index) => ({
    id: `local-${file.lastModified}-${file.size}-${index}`,
    filename: file.name,
    contentType: file.type || undefined,
    size: file.size,
    pending: true,
  }));
